// Google Analytics 4 (gtag.js), Turbo Drive aware.
//
// Why this lives in the JS bundle (not an inline <head> script):
//   - It runs EXACTLY ONCE. Turbo Drive swaps the <body> on navigation and
//     re-appends head scripts whose markup changed (our CSP nonce changes every
//     request), so an inline turbo:load listener would re-register and the page
//     would double/triple count. A bundled module registers the listener a
//     single time.
//   - Turbo Drive navigations are NOT full page loads, so gtag's automatic
//     page_view (which only fires on the real document load) would MISS every
//     in-app navigation. We disable it (send_page_view: false) and instead send
//     exactly one page_view on `turbo:load`, which fires on the initial load AND
//     after every Turbo visit. One navigation -> one page_view. No more, no less.
//
// Activated only when the server rendered <meta name="ga-id"> (production only),
// so development and test never send analytics or load the remote script.
export function startGoogleAnalytics() {
  const gaId = document.querySelector('meta[name="ga-id"]')?.content
  if (!gaId) return

  // Load gtag.js. The host is allowlisted in the production CSP script_src.
  const tag = document.createElement('script')
  tag.async = true
  tag.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gaId)}`
  document.head.appendChild(tag)

  window.dataLayer = window.dataLayer || []
  function gtag() {
    window.dataLayer.push(arguments)
  }
  window.gtag = gtag

  gtag('js', new Date())
  // Disable the automatic page_view; we send our own on every turbo:load.
  gtag('config', gaId, { send_page_view: false })

  document.addEventListener('turbo:load', () => {
    // Pass the live URL/title: gtag caches them at load time and would otherwise
    // report the FIRST page for every subsequent Turbo navigation.
    gtag('event', 'page_view', {
      page_location: window.location.href,
      page_title: document.title,
    })
  })
}
